import {HttpEventType} from '@angular/common/http';
import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FileUploader} from 'ng2-file-upload';
import {ProgressbarConfig} from 'ngx-bootstrap/progressbar';
import {PageContentService} from "../../../services/help/pagecontent.service";
import {PageContent} from '@app/models/help/pagecontent.model';
import {FunctionsComponent} from './functions/functions.component';
import {PageContentFunctionService} from '@app/services/help/pagecontentfunction.service';
import {DataType} from "@app/models/shared/datatype.enum";
import {Section} from "@app/models/help/section.model";
import {SectionService} from "@app/services/help/section.service";
import swal from "sweetalert";
import {ToastrService} from "ngx-toastr";
import {clonify} from "@app/shared/utils/object.utils";
import { Environment } from '@env/environment.global';

//const settings = require("appsettings.json");

export function getProgressbarConfig(): ProgressbarConfig {
  return Object.assign(new ProgressbarConfig(), {animate: true, striped: true, max: 100});
}

@Component({
  selector: 'app-pagecontentadmin',
  templateUrl: './pagecontentadmin.component.html',
  styleUrls: ['./pagecontentadmin.component.scss'],
  providers: [{provide: ProgressbarConfig, useFactory: getProgressbarConfig}]
})

export class PageContentAdminComponent implements OnInit {

  @ViewChild(FunctionsComponent, { static: true })
  public functionsComponent: FunctionsComponent;

  public sections:Section[];

  public pageContents: PageContent[];
  public url: string;

  public isFormOpen: boolean = false;
  public pageContentFormGroup: FormGroup;

  public pageContent: PageContent = new PageContent();
  public isInUpdateMode: boolean = false;
  public selectedFile;

  public contentIsNull = () => { return this.pageContentFormGroup.value.content == '' || this.pageContentFormGroup.value.content == null };
  public showImageRequired = () => { return this.pageContent.image == null || this.pageContent.image == '' || this.pageContent.image == undefined };

  public uploadPercentage = 0;

  public uploader: FileUploader;

  public options: Object = {
    imageUploadURL: 'api/PageContentService/upload-editor-image',
    key: 'mB1A4C1A1B1C2pI1A1A1E7A1A5E5A1I4B3kWa1WDPTf1ZNRGb1OG1g1==',
    tableStyles: {
      alternateRow: 'Alternate Row',
      thinBorder: 'Thin Border',
      thickBorder: 'Thick Border',
      blackBorder: 'Black Border',
      grayBorder: 'Gray Border'
    }
  };

  constructor(private pageContentService: PageContentService,
              private pageContentFunctionService: PageContentFunctionService,
              private toasterService: ToastrService,
              private sectionService:SectionService,
              private formBuilder: FormBuilder,
              private environment: Environment) {
    this.url = this.environment.getBaseUrl();
    this.uploader = new FileUploader({url: this.url});
    this.createForm();
  }

  public createForm() {
    this.pageContentFormGroup = this.formBuilder.group({
      title: [null, Validators.required],
      content: [null, Validators.required],
      searchHeader: [null, Validators.required],
      sectionId: [null, Validators.required]
    });
  }

  public ngOnInit() {
    this.bindPageContents();
    this.bindSections();
  }

  private bindSections(){
    this.sectionService.getList().subscribe(result=>{
      this.sections = result;
    })
  }

  public edit(pageContent: PageContent) {
    this.isFormOpen = true;
    this.pageContent = clonify(pageContent);
    this.pageContentFormGroup.patchValue(this.pageContent);
    this.isInUpdateMode = true;
    if (!pageContent.pageContentFunctions || pageContent.pageContentFunctions.length <= 0) {
      this.pageContentFunctionService.getList(this.pageContent.id).subscribe(result => {
        this.pageContent.pageContentFunctions = result;
        this.pageContent.pageContentFunctions.forEach(pageContentFunction => {
          pageContentFunction.dataType = DataType.NoChange;
        });
        this.functionsComponent.setComponentData(this.pageContent.pageContentFunctions);
      });
    }

  }

  public delete(id) {
    swal({
      title: 'Are you sure?',
      text: '',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'No, cancel please!',
          visible: true,
          closeModal: true
        },
        confirm: {
          text: 'Yes, delete it!',
          value: true,
          visible: true,
          className: 'bg-danger',
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.pageContentService.delete(id).subscribe(() => {
          this.bindPageContents();
        });
      }
    });
  }

  public newPageContent() {
    this.isFormOpen = !this.isFormOpen;
  }

  public bindPageContents() {
    this.pageContentService.getList().subscribe(result => {
      this.pageContents = <PageContent[]>(result);
    });
  }

  public onUpload() {
    if (this.selectedFile == null) {
      return;
    }
    let formData = new FormData();
    formData.append("file", this.selectedFile, this.selectedFile.name);

    this.pageContentService.uploadImage(formData).subscribe(event => {
      if (event.type == HttpEventType.UploadProgress) {
        this.uploadPercentage = Math.round((<any>event).loaded / (<any>event).total * 100);
      } else if (event.type == HttpEventType.Response) {
        this.pageContent.image = <string>(<any>event).body.value;
      }
    });
  }

  public onFileChanged(event) {
    if (event.length <= 0) {
      return;
    }
    this.selectedFile = event.target.files[0];
    this.onUpload();
  }

  public submitForm(form) {
    let isValid = this.pageContentFormGroup.valid;

    if (this.contentIsNull()) {
      return;
    }

    if (this.showImageRequired()) {
      return;
    }

    let process;
    this.pageContent = { ...this.pageContent, ...this.pageContentFormGroup.value };

    if (this.isInUpdateMode) {
      process = this.pageContentService.update(this.pageContent);
    } else {
      process = this.pageContentService.insert(this.pageContent);
    }

    process.subscribe(() => {
      this.isInUpdateMode = false;
      this.bindPageContents();
      this.clearForm(form);
      this.toasterService.success('Data is saved successfully.', 'Success');
    });

  }

  public clearForm(form) {
    this.pageContent = new PageContent();
    this.functionsComponent.setComponentData([]);
    this.functionsComponent.clearState();
    form.resetForm();
  }

  public getPageContentType(type) {
    if (type == 1) {
      return 'Help Page';
    }
  }

  onFunctionsChanged($event) {
    this.pageContent.pageContentFunctions = $event;
    this.pageContent.pageContentFunctions = this.pageContent.pageContentFunctions.sort((a, b) => {
      if(a.categoryName == b.categoryName){
        return a.functionName > b.functionName ? 1 : -1;
      }
      return a.categoryName > b.categoryName ? 1 : -1;
    });
  }
}
